import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface Error500Props {
  errorId?: string;
}

const Error500 = ({ errorId }: Error500Props) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <p className="mb-2 text-2xl font-bold tracking-tight text-primary">Farmly</p>
          <CardTitle className="text-xl">Det blev lite fel här</CardTitle>
          <CardDescription>
            Prova igen om en stund. Om det fortsätter, hör av dig.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button onClick={() => window.location.reload()}>Försök igen</Button>
          <Button variant="outline" onClick={() => { window.location.href = '/'; }}>
            Till startsidan
          </Button>
          {errorId && (
            <p className="text-xs text-muted-foreground">Fel-id: {errorId}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Error500;
